import cx from 'classnames'
import PropTypes from 'prop-types'
import React, { PureComponent } from 'react'
import TitleCard from 'components/shared/TitleCard'
import styles from './styles.styl'
import { Button } from '@driftt/tide-core-legacy'

export const Row = ({ children, style = {}}) => (
  <div className="settings-section-row" style={{ ...style }}>
    {children}
  </div>
)

const Title = ({ title, action }) => (
  <div className={styles.Title}>
    <div className="dsg-h3 card-section-title">{title}</div>
    {action}
  </div>
)

export class Section extends PureComponent {
  render() {
    const { title, subtitle, action, children, className } = this.props
    return (
      <TitleCard
        className={cx(styles.Section, className)}
        title={<Title title={title} action={action} />}
        subtitle={subtitle}
      >
        {children}
      </TitleCard>
    )
  }
}

export class Subsection extends PureComponent {
  static propTypes = {
    title: PropTypes.string.isRequired,
    isValid: PropTypes.bool.isRequired,
    canSubmit: PropTypes.bool.isRequired,
    onSubmit: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    className: PropTypes.string,
    innerClassName: PropTypes.string,
    loading: PropTypes.bool,
  }

  render() {
    const { title, children, loading = false, className, innerClassName } = this.props
    return (
      <div className={cx(styles.Subsection, className, { loading })}>
        <div className={cx(styles.Subsection__Title)}>{title}</div>
        <div className={cx(styles.Subsection__Body, innerClassName)}>{children}</div>
        {this.renderSave()}
      </div>
    )
  }

  renderSave() {
    const { canSubmit, isValid, loading = false, onSubmit, onCancel } = this.props
    return (
      <div className="action-controls shown">
        <Button
          size="medium"
          className={cx('save', { loading })}
          onClick={onSubmit}
          disabled={loading || !isValid || !canSubmit}
        >
          {loading ? 'Saving...' : 'Save'}
        </Button>
        <div className="cancel" onClick={onCancel}>
          Cancel
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/scripts/components/settings/UserProfile/Section/index.js